var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { useMemo } from 'react';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { versionsApi } from '@data/rest/api';
import * as baobab from '@data/baobab/baobab';
import { TagQueryKeys } from '@data/tag/types';
import { addQueryClientArrayMember, removeQueryClientArrayMember, updateQueryClientArrayMember, } from '@util/query';
var QUERY_KEY = ['versions'];
function getVersions() {
    return versionsApi.list();
}
export function useVersions(options) {
    return useQuery(QUERY_KEY, getVersions, __assign({ staleTime: 5000 }, options));
}
function filterActiveVersions(versions) {
    return versions.filter(function (v) { return v.active; }).sort(function (a, b) { return a.order - b.order; });
}
export function useActiveVersions() {
    var data = useVersions({ notifyOnChangeProps: ['data'], select: filterActiveVersions }).data;
    return useMemo(function () {
        if (data) {
            return data;
        }
        return [];
    }, [data]);
}
export function useShownVersions(settings) {
    var e_1, _a;
    var activeVersions = useActiveVersions();
    var shownVersions = [];
    try {
        for (var activeVersions_1 = __values(activeVersions), activeVersions_1_1 = activeVersions_1.next(); !activeVersions_1_1.done; activeVersions_1_1 = activeVersions_1.next()) {
            var version = activeVersions_1_1.value;
            if (settings.model_table_filtered_versions.includes(version.id)) {
                shownVersions.push(version);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (activeVersions_1_1 && !activeVersions_1_1.done && (_a = activeVersions_1.return)) _a.call(activeVersions_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return shownVersions;
}
export function useVersionsActions() {
    var _this = this;
    var queryClient = useQueryClient();
    var add = useMutation(function (name) { return versionsApi.create({ name: name, hexColor: '', active: true }); }, {
        onSuccess: function (version) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(QUERY_KEY)];
                    case 1:
                        _a.sent();
                        addQueryClientArrayMember(queryClient, QUERY_KEY, version);
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries(QUERY_KEY)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, queryClient.invalidateQueries(TagQueryKeys.Tags)];
                    case 2:
                        _a.sent();
                        // delete all downloaded datagroups to force fetching new ones with new variation
                        baobab.root.select('models', 'datagroups').set({});
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var update = useMutation(function (version) { return versionsApi.update(version.id, version); }, {
        onMutate: function (version) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(QUERY_KEY)];
                    case 1:
                        _a.sent();
                        updateQueryClientArrayMember(queryClient, QUERY_KEY, version);
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(QUERY_KEY);
                queryClient.invalidateQueries(TagQueryKeys.Tags);
                // delete all downloaded datagroups to force fetching new ones with new variation
                baobab.root.select('models', 'datagroups').set({});
                return [2 /*return*/];
            });
        }); },
    });
    var remove = useMutation(function (version) { return versionsApi.remove(version.id); }, {
        onMutate: function (version) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.cancelQueries(QUERY_KEY)];
                    case 1:
                        _a.sent();
                        removeQueryClientArrayMember(queryClient, QUERY_KEY, version.id);
                        return [2 /*return*/];
                }
            });
        }); },
        onSettled: function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                queryClient.invalidateQueries(QUERY_KEY);
                queryClient.invalidateQueries(TagQueryKeys.Tags);
                // delete all downloaded datagroups to force fetching new ones with new variation
                baobab.root.select('models', 'datagroups').set({});
                return [2 /*return*/];
            });
        }); },
    });
    return {
        addVersion: add.mutateAsync,
        updateVersion: update.mutateAsync,
        deleteVersion: remove.mutateAsync,
    };
}
